export default ({ value, alignment, id }) => {
  return { alignment, doc: value, enableRenderer: true, id };
};
